import { call, put, takeLatest } from 'redux-saga/effects'

import { signupUser } from './index.reducer'
import Api from '../../services/ApiCaller'

export function* signupRequest(api: any, { payload }: any) {
  try {
    try {
      const { res = {} } = yield call(Api.callServer, api, payload)
      const { data, success } = res
      if (success && data) {
        yield put(signupUser.success(data))
      } else {
        yield put(signupUser.failure(''))
      }
    } catch (e) {
      yield put(signupUser.failure())
    }
    yield
  } catch ({ message }) {}
}

export default (api: any) => {
  const signupApi = (data: any) => {
    return api.post('/users/signup/', data)
  }
  return [takeLatest(signupUser.TRIGGER, signupRequest, signupApi)]
}
